/*
 * - Definitions for Lookup queries
 */
import { useGeospatial } from '@stores';
import GeospatialService from './service';
import {
  AddressSuggestionsResponse,
  GeocodeResponse,
  GeometryResponse,
  ReverseGeocodeData,
  ValidationErrorResponse,
} from './types';
//@ts-ignore
import * as turf from '@turf/turf';

export const isGeometryResponse = (data: GeometryResponse | ValidationErrorResponse): data is GeometryResponse =>
  !!(data as GeometryResponse)?.data?.features;

export const GEOSPATIAL_QUERY_KEYS = {
  FIND_ADDRESS_CANDIDATES: 'FIND_ADDRESS_CANDIDATES',
  SUGGEST: 'SUGGEST',
  REVERSE_GEOCODE: 'REVERSE_GEOCODE',
  GET_GEOMETRY_DATA: 'GET_GEOMETRY_DATA',
  GET_GEOMETRY_DATA_FIRST_POLYGON: 'GET_GEOMETRY_DATA_FIRST_POLYGON',
  VALIDATE_ADDRESS: 'VALIDATE_ADDRESS',
};

const {
  setProjectLocationAddress,
  setResourceGeometryData,
  setProjectGeometryData,
  setAddressSuggestions,
  setAddressCandidates,
} = useGeospatial.getState();

export default class GeospatialQueries {
  public static readonly findAddressCandidates = async (
    address: string,
    magicKey?: string
  ): Promise<GeocodeResponse> => {
    const data = await GeospatialService.getAddressCandidates(address, magicKey);
    setAddressCandidates(data?.candidates || []);
    return data;
  };
  public static readonly reverseGeocode = async (location: string, local: boolean): Promise<ReverseGeocodeData> => {
    const result = await GeospatialService.getReverseGeocode(location, local);
    const data = typeof result?.data === 'string' ? JSON.parse(result.data) : result?.data;
    setProjectLocationAddress(data?.address);
    return data;
  };
  public static readonly suggest = async (
    text: string,
    location: string,
    usOnly: boolean
  ): Promise<AddressSuggestionsResponse> => {
    const data = await GeospatialService.getSuggest(text, location, usOnly);
    setAddressSuggestions(data?.suggestions || []);
    return data;
  };
  public static readonly getGeometryData = async (
    gdbFile: File,
    firstPolygonOnly: boolean
  ): Promise<GeometryResponse | ValidationErrorResponse> => {
    const data = await GeospatialService.getGeometryData(gdbFile, firstPolygonOnly);

    if (isGeometryResponse(data)) {
      if (firstPolygonOnly) {
        setProjectGeometryData(data.data);
      } else {
        const rightedGeometry = turf.flip(data.data);
        setResourceGeometryData(rightedGeometry);
      }
    }
    return data;
  };
}
